import type { NavItem, NavLinkItem } from '../types/content';

export const primaryNav: NavItem[] = [
  {
    label: 'About',
    to: '/about',
    children: [
      { label: 'About Us', to: '/about', description: 'Our philosophy, values, and approach' },
      { label: 'Our Consultants', to: '/consultants', description: 'Meet the executive search team' },
    ],
  },
  {
    label: 'Expertise',
    to: '/expertise',
    children: [
      { label: 'Our Expertise', to: '/expertise', description: 'Eight executive search services' },
      { label: 'Industries', to: '/industries', description: 'Sectors we are positioned to serve' },
    ],
  },
  { label: 'For Employers', to: '/employers' },
  {
    label: 'For Candidates',
    to: '/candidates',
    children: [
      { label: 'For Candidates', to: '/candidates', description: 'Introduce your leadership background' },
      { label: 'Leadership Opportunities', to: '/opportunities', description: 'Approved executive opportunities' },
    ],
  },
  { label: 'Insights', to: '/insights' },
  { label: 'Contact', to: '/contact' },
];

export const mobileNav: NavLinkItem[] = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Our Expertise', to: '/expertise' },
  { label: 'Industries', to: '/industries' },
  { label: 'Our Consultants', to: '/consultants' },
  { label: 'For Employers', to: '/employers' },
  { label: 'For Candidates', to: '/candidates' },
  { label: 'Leadership Opportunities', to: '/opportunities' },
  { label: 'Insights', to: '/insights' },
  { label: 'Contact Us', to: '/contact' },
];

export const firmNav: NavLinkItem[] = [
  { label: 'About Us', to: '/about' },
  { label: 'Our Consultants', to: '/consultants' },
  { label: 'For Employers', to: '/employers' },
  { label: 'For Candidates', to: '/candidates' },
  { label: 'Leadership Opportunities', to: '/opportunities' },
  { label: 'Insights', to: '/insights' },
  { label: 'Contact Us', to: '/contact' },
];

export const legalNav: NavLinkItem[] = [
  { label: 'Privacy Policy', to: '/privacy' },
  { label: 'Terms of Use', to: '/terms' },
  { label: 'Accessibility Statement', to: '/accessibility' },
  { label: 'Cookie Policy', to: '/cookies' },
  { label: 'Sitemap', to: '/sitemap' },
];
